import { Controller } from "@hotwired/stimulus"

// Плавное появление блока при попадании в зону видимости.
// JS-first: без JS/при reduced-motion контент виден сразу (см. CSS).
export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.element.classList.add("pc-reveal")
    Array.from(this.element.children).forEach((child, i) => {
      child.style.transitionDelay = `${i * 80}ms`
    })

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          this.element.classList.add("pc-revealed")
          this.observer.disconnect()
        })
      },
      { threshold: 0.15 }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
